import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../lib/api';

export interface SendMagicLinkPayload {
  email: string;
  return_to?: string;
}

export function useSendMagicLink() {
  const api = useApi();
  return useMutation({
    mutationFn: async ({ email, return_to }: SendMagicLinkPayload): Promise<void> => {
      const { error, response } = (await api.POST('/auth/magic-link/send' as never, {
        body: { email, ...(return_to ? { return_to } : {}) },
      } as never)) as { data?: unknown; error?: unknown; response: Response };
      if (error) {
        const err = new Error('send_magic_link_failed') as Error & {
          status?: number;
          body?: unknown;
        };
        err.status = response?.status;
        err.body = error;
        throw err;
      }
    },
  });
}
